import React, { memo } from "react";
import { Header } from "_c/Modals";
import { Button } from "_c/button";
// import Avatar from "_c/Avatar";
import { MASTER_CLIENTS_NS as ns } from "@/i18n/ns";
import Stats from "./Stats";
import type { tBizClient } from "@/types";
import type { TFunction } from "i18next";
import { analyticsAction } from "@/utils/analytics";
import { useMut } from "@/hooks/useMut";
import { ClientsService } from "@/services/clients";
import { CircleButton } from "_c/button";
import TrashIcon from "_c/icon/Trash";
import GearIcon from "_c/icon/Gear";

type tProps = {
  client: tBizClient;
  isBookingDisabled?: boolean;
  onBookClick: tVoidFn;
  t: TFunction;
  onRemove: (client: tBizClient) => any;
  isActionsDisabled?: boolean;
  onEdit?: tVoidFn;
};
const ClientHeader = ({
  client,
  isBookingDisabled,
  isActionsDisabled,
  onBookClick,
  onEdit,
  onRemove,
  t,
}: tProps) => {
  const onEditClick = () => {
    if (!onEdit) return;
    onEdit();
    analyticsAction({
      category: "clients",
      action: "card_change_click",
    });
  };
  const removeMut = useMut(ClientsService.removeClient, {
    confirmText: t("common:rm_client_popover.title"),
    t,
    notifyOnError: true,
    onSuccess() {
      onRemove(client);
    },
  });
  return (
    <Header
      as="div"
      css={`
        display: flex;
        justify-content: space-between;
        padding: 10px 15px;
        padding-bottom: 5px;
        cursor: default;
        border-bottom: none;
      `}
    >
      <div
        css={`
          padding-right: 15px;
        `}
      >
        <div
          css={`
            font-weight: 700;
            font-size: 16px;
            margin-bottom: 5px;
          `}
        >
          {client.full_name}
        </div>
        <Stats
          t={t}
          client={client}
          css={`
            margin: 15px 0;
          `}
        />
        <div
          css={`
            font-size: 14px;
          `}
        >
          <div
            css={`
              display: flex;
              align-items: center;
              > * {
                margin-inline-end: 15px;
              }
            `}
          >
            {!isBookingDisabled && (
              <Button onClick={onBookClick} small greenish>
                {t("common:profile_links.add_task")}
              </Button>
            )}

            {!isActionsDisabled && (
              <>
                <CircleButton onClick={onEditClick} medium>
                  <GearIcon width="18" />
                </CircleButton>
                <CircleButton
                  disabled={removeMut.isLoading}
                  onClick={() => removeMut.mutate(client)}
                  medium
                  negative
                >
                  <TrashIcon width="18" />
                </CircleButton>
              </>
            )}
          </div>
          {client.banned && (
            <div
              css={`
                color: var(--color-danger);
                font-weight: 700;
                margin-top: 10px;
              `}
            >
              {t(`${ns}:banned_text`)}
            </div>
          )}
        </div>
      </div>
      {/* <Avatar size="lg" avatar={client.avatar} sex={client.sex} /> */}
    </Header>
  );
};

export default memo(ClientHeader);
